import axios from "axios";
import { API_URL } from "../config/apiUrl";

// Create an instance of axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
  },
});

// Set up axios to include the token in all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("sessionToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
